module.exports = "/out/b8c8e5237da3c04fd2210dc789e8f5ce.svg";